import { Component, Output, EventEmitter, Input, inject } from '@angular/core';
import { SkipInteraction } from '@shared/store';
import { VoiceCheckService } from '../voice-check.service';

@Component({
  selector: 'app-media-access',
  templateUrl: './media-access.component.html',
  styleUrls: ['./media-access.component.scss'],
  standalone: false,
})
export class MediaAccessComponent {
  private readonly voiceCheckService = inject(VoiceCheckService);

  public readonly interaction = SkipInteraction.MicrophoneConsentPage;

  @Input() showBrowserProblemLink: boolean = false;
  @Output() next = new EventEmitter();

  buttonClick() {
    this.voiceCheckService.rememberConsent();
    this.next.emit();
  }
}
